import { IListBiddingRequest } from "../../model/base/request/list-bidding-request";
import { IListNewsRequest } from "../../model/base/request/list-news-request";
import { IListOfficialDailyRequest } from "../../model/base/request/list-official-daily-request";
import { IListPublicAccountRequest } from "../../model/base/request/list-public-account-request";
import { IListQuestionAnwserRequest } from "../../model/base/request/list-question-anwser-request";
import { IListUsefulLinksRequest } from "../../model/base/request/list-useful-links-request";
import { IListAuditsRequest } from "../../model/base/request/list-audits-request";
import { IListGovernmentProjectsRequest } from "../../model/base/request/list-government-projects-request";
import { IListPurchaseContractsRequest } from "../../model/base/request/list-purchase-contracts-request";
import { IListAgreementsRequest } from "../../model/base/request/list-agreements-request";
import { IContactUsRequest } from "../../model/base/request/contact-us-request";
import { ISearchRequest } from "../../model/base/request/search-request";
import { IListPublicationsRequest } from "../../model/base/request/list-publications-request";
import { IBannerReponse } from "../../model/base/response/banner-response";
import { IBiddingResponse } from "../../model/base/response/bidding-response";
import { IBiddingDetailResponse } from "../../model/base/response/bidding-detail-response";
import { IGroupedBidsYearResponse } from "../../model/base/response/grouped-bids-year-response";
import { IGroupedDailyOfficialResponse } from "../../model/base/response/grouped-daily-official-response";
import { IGroupedPublicAccountBySubCategoryResponse } from "../../model/base/response/grouped-public-account-subcategory-response";
import { IManagementUnitResponse } from "../../model/base/response/management-unit-response";
import { IMenuResponse } from "../../model/base/response/menu-response";
import { INewsDetailReponse } from "../../model/base/response/news-detail-response";
import { INewsReponse } from "../../model/base/response/news-response";
import { INewsCategoryResponse } from "../../model/base/response/news-category-response";
import { IOfficialDailyResponse } from "../../model/base/response/official-daily-response";
import { IParametersPortalReponse } from "../../model/base/response/parameters-portal-response";
import { IPublicAccountResponse } from "../../model/base/response/public-account-response";
import { IQuestionAnwserReponsae } from "../../model/base/response/question-awnser-respons";
import { IUsefulLinkResponse } from "../../model/base/response/useful-links-response";
import { IAuditResponse, IAuditDetailResponse } from "../../model/base/response/audit-response";
import { IGovernmentProjectResponse, IGovernmentProjectDetailResponse } from "../../model/base/response/government-project-response";
import { IPurchaseContractResponse, IPurchaseContractDetailResponse } from "../../model/base/response/purchase-contract-response";
import { IPurchaseContractFileResponse } from "../../model/base/response/purchase-contract-file-response";
import { IOfficialDailyDetailResponse } from "../../model/base/response/official-daily-detail-response";
import { IAgreementResponse, IAgreementDetailResponse } from "../../model/base/response/agreement-response";
import { ICategoryLinkResponse } from "../../model/base/response/category-link-response";
import { IGlobalSearchResultDto } from "../../model/base/response/search-response";
import { IPublicationResponse, IPublicationDetailResponse } from "../../model/base/response/publication-response";
import { ICategoryWithSubcategoriesResponse } from "../../model/base/response/category-with-subcategories-response";
import { IArticleResponse } from "../../model/base/response/article-response";
import { Pagination } from "../../model/paginatiion";
import HttpClient from "../services/http-client";

const defaultPath = 'Portal';

const listMenus = async (): Promise<IMenuResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Menus`
    }).then((response) => Object.assign([], response.data));
};

const listBanners = async (): Promise<IBannerReponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Banners`
    }).then((response) => Object.assign([], response.data));
};
const listNewsLimit = async (limit: number): Promise<Pagination<INewsReponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News`,
        params: { page: 0, pageSize: limit }
    }).then((response) => Object.assign(new Pagination<INewsReponse>(), response.data));
};

const getParameters = async (): Promise<IParametersPortalReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Parameters`,
    }).then((response) => Object.assign({} as IParametersPortalReponse, response.data));
};

const listGroupedBidsModality = async (): Promise<IGroupedBidsYearResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Grouped/BidsModality`
    }).then((response) => Object.assign([], response.data));
};

const listGroupedDailyOfficial = async (): Promise<IGroupedDailyOfficialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Grouped/DailyOfficial`
    }).then((response) => Object.assign([], response.data));
};


const listPublicAccountSubcategory = async (): Promise<IGroupedPublicAccountBySubCategoryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Grouped/PublicAccountCategopry`
    }).then((response) => Object.assign([], response.data));
};

const listManagementUnit = async (): Promise<IManagementUnitResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ManagementUnit`
    }).then((response) => Object.assign([], response.data));
};

const listPublicAccount = async (params: IListPublicAccountRequest): Promise<Pagination<IPublicAccountResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PublicAccount`,
        params
    }).then((response) => Object.assign(new Pagination<IPublicAccountResponse>(), response.data));
};

const listQuestionAwnser = async (params: IListQuestionAnwserRequest): Promise<Pagination<IQuestionAnwserReponsae>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/QuestionAnswer`,
        params
    }).then((response) => Object.assign(new Pagination<IQuestionAnwserReponsae>(), response.data));
};
const listOfficialDaily = async (params: IListOfficialDailyRequest): Promise<Pagination<IOfficialDailyResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/OfficialDaily`,
        params
    }).then((response) => Object.assign(new Pagination<IOfficialDailyResponse>(), response.data));
};

const getOfficialDailyDetail = async (id: number): Promise<IOfficialDailyDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/OfficialDaily/${id}`
    }).then((response) => Object.assign({} as IOfficialDailyDetailResponse, response.data));
};

const getNewsDetail = async (id: number): Promise<INewsDetailReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News/${id}`
    }).then((response) => Object.assign({} as INewsDetailReponse, response.data));
};
const listBidding = async (params: IListBiddingRequest): Promise<Pagination<IBiddingResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Bidding`,
        params
    }).then((response) => Object.assign(new Pagination<IBiddingResponse>(), response.data));
};

const getBiddingDetail = async (id: number): Promise<IBiddingDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Bidding/${id}`
    }).then((response) => Object.assign({} as IBiddingDetailResponse, response.data));
};

const listNews = async (params: IListNewsRequest): Promise<Pagination<INewsReponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News`,
        params
    }).then((response) => Object.assign(new Pagination<INewsReponse>(), response.data));
};

const listNewsCategories = async (): Promise<INewsCategoryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/NewsCategories`
    }).then((response) => Object.assign([], response.data));
};

// Links Úteis
const requestUsefulLinks = async (params: IListUsefulLinksRequest): Promise<Pagination<IUsefulLinkResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Links`,
        params
    }).then((response) => Object.assign(new Pagination<IUsefulLinkResponse>(), response.data));
};

// Auditoria
const requestAudits = async (params: IListAuditsRequest): Promise<Pagination<IAuditResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Audits`,
        params
    }).then((response) => Object.assign(new Pagination<IAuditResponse>(), response.data));
};

const requestAuditDetail = async (id: number): Promise<IAuditDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Audits/${id}`
    }).then((response) => Object.assign({} as IAuditDetailResponse, response.data));
};

// Projetos Governamentais
const requestGovernmentProjects = async (params: IListGovernmentProjectsRequest): Promise<Pagination<IGovernmentProjectResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernmentProjects`,
        params
    }).then((response) => Object.assign(new Pagination<IGovernmentProjectResponse>(), response.data));
};

const requestGovernmentProjectDetail = async (id: number): Promise<IGovernmentProjectDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernmentProjects/${id}`
    }).then((response) => Object.assign({} as IGovernmentProjectDetailResponse, response.data));
};

// Contratos e Aquisições
const requestPurchaseContracts = async (params: IListPurchaseContractsRequest): Promise<Pagination<IPurchaseContractResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PurchaseContracts`,
        params
    }).then((response) => Object.assign(new Pagination<IPurchaseContractResponse>(), response.data));
};

const requestPurchaseContractDetail = async (id: number): Promise<IPurchaseContractDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PurchaseContracts/${id}`
    }).then((response) => Object.assign({} as IPurchaseContractDetailResponse, response.data));
};

const requestPurchaseContractFiles = async (id: number): Promise<IPurchaseContractFileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Contract/${id}/Files`
    }).then((response) => Object.assign([], response.data.items || response.data));
};

// Convênios e Repasses
const requestAgreements = async (params: IListAgreementsRequest): Promise<Pagination<IAgreementResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Agreements`,
        params
    }).then((response) => Object.assign(new Pagination<IAgreementResponse>(), response.data));
};

const requestAgreementDetail = async (id: number): Promise<IAgreementDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Agreements/${id}`
    }).then((response) => Object.assign({} as IAgreementDetailResponse, response.data));
};

// Link Categories
const requestLinkCategories = async (): Promise<ICategoryLinkResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/LinkCategories`
    }).then((response) => Object.assign([], response.data));
};

// Contact Us
const sendContactMessage = async (request: IContactUsRequest): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/ContactUs`,
        data: request
    }).then((response) => response.data);
};

// Search
const searchPortal = async (params: ISearchRequest): Promise<IGlobalSearchResultDto> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Search`,
        params
    }).then((response) => Object.assign({} as IGlobalSearchResultDto, response.data));
};

const requestPublications = async (params: IListPublicationsRequest): Promise<Pagination<IPublicationResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Publications`,
        params
    }).then((response) => Object.assign(new Pagination<IPublicationResponse>(), response.data));
};

const requestPublicationDetail = async (id: number): Promise<IPublicationDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Publications/${id}`
    }).then((response) => Object.assign({} as IPublicationDetailResponse, response.data));
};

const listCategoriesWithSubcategories = async (): Promise<ICategoryWithSubcategoriesResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoriesWithSubcategories`
    }).then((response) => Object.assign([], response.data));
};

const getArticle = async (id: number): Promise<IArticleResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Articles/${id}`
    }).then((response) => Object.assign({} as IArticleResponse, response.data));
};

const PortalAppService = {
    listPublicAccount,
    getNewsDetail,
    listBidding,
    getBiddingDetail,
    listQuestionAwnser,
    listOfficialDaily,
    getOfficialDailyDetail,
    listMenus,
    listBanners,
    listNewsLimit,
    listNews,
    listNewsCategories,
    getParameters,
    listGroupedBidsModality,
    listGroupedDailyOfficial,
    listPublicAccountSubcategory,
    listManagementUnit,
    requestUsefulLinks,
    requestAudits,
    requestAuditDetail,
    requestGovernmentProjects,
    requestGovernmentProjectDetail,
    requestPurchaseContracts,
    requestPurchaseContractDetail,
    requestPurchaseContractFiles,
    requestAgreements,
    requestAgreementDetail,
    requestLinkCategories,
    sendContactMessage,
    searchPortal,
    requestPublications,
    requestPublicationDetail,
    listCategoriesWithSubcategories,
    getArticle
};

export default PortalAppService;